import Header from '../../Core/Header/variants/Offer';
import { Container, Content, BodyText, Title } from './ErrorBoundry.styles';
import * as content from './ErrorBoundary.content';

const ErrorDisplay = () => (
  <Container>
    <Header error />
    <Content>
      <Title>{content.actionMessage}</Title>
      <BodyText>{content.bodyText}</BodyText>
    </Content>
  </Container>
);

export default ErrorDisplay;
